import { PillType } from './../../../shared/components/pill/pill.model';
import { ChangeDetectionStrategy, Component, Input, QueryList, ViewChildren } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

import { Feature, RoomCommands, RoomProperties } from '@vi-iot/client';

import { GatewayStore, UnassignableDeviceDisconnected } from '@store';
import { matTooltipSetter } from '../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';

@Component({
  selector: 'app-room-warning',
  templateUrl: './room-warning.component.html',
  styleUrls: ['./room-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RoomWarningComponent {
  @Input() room: Feature<RoomProperties, RoomCommands>;
  @Input() isUnAssignablePanel: boolean;
  @Input() unassignableDeviceStatus: UnassignableDeviceDisconnected;
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }
  readonly pillType = PillType;
  constructor(public gatewayStore: GatewayStore) {}
}
